import BulkTagging from 'components/BulkTagging/BulkTagging';
import React from 'react';
import { BulkTaggingActions, BulkTaggingContainer } from './Theme';

const BulkTaggingModal = ({ closeModal,addTagHandler,addTagLoading }) => {
  
  return (
    <BulkTaggingContainer>
      <BulkTagging
        modelType={false}
        type="account"
        addTagDirectory={true}
        closeModal={closeModal}
        addTagHandler={addTagHandler}
        addTagLoading={addTagLoading}
        title="Add tags to the account"
      />
    </BulkTaggingContainer>
  )
}

export default BulkTaggingModal